export default __webpack_public_path__ + "static/media/colecao.69d80036.webp";